import React, { VFC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectBridgeSlice } from '../../../redux/slices/bridgeSlice';
import { useTransactionProgress } from '../../../hooks';

const Tutorial: VFC = () => {
  const { txIsOngoing, selectedToken, selectedFromChain, selectedToChain } =
    useSelector(selectBridgeSlice);

  const transactionProgress = useTransactionProgress();

  const currentStep = useMemo(() => {
    if (txIsOngoing) {
      return `Step${transactionProgress.step}`;
    }

    if (selectedFromChain && selectedToChain) {
      return `Step3`;
    }

    if (selectedToken) {
      return `Step2`;
    }

    return `Step1`;
  }, [
    selectedFromChain,
    selectedToChain,
    selectedToken,
    transactionProgress.step,
    txIsOngoing,
  ]);

  return (
    <div className="aside column col-3 wow fadeInLeft" data-wow-delay="0.5s">
      <div className="tutorial">
        <div
          className={`tutorial-step ${
            currentStep === `Step1` ? `current-step` : ``
          }`}
        >
          <em>1</em>
          <span>Select a token to convert.</span>
        </div>
        <div
          className={`tutorial-step ${
            currentStep === `Step2` ? `current-step` : ``
          }`}
        >
          <em>2</em>
          <ul>
            <li>
              Select Chains and Connect a Wallet.
              <br />
              Both From Wallet and To wallet should be connected.
            </li>
          </ul>
        </div>
        <div
          className={`tutorial-step ${
            currentStep === `Step3` ? `current-step` : ``
          }`}
        >
          <em>3</em>
          <ul>
            <li>
              Enter amount and click convert button.
              <br />
              Follow guidance and Proceed approval process.
            </li>
          </ul>
        </div>
        <div
          className={`tutorial-step ${
            currentStep === `Step4-1` ||
            currentStep === `Step4-2` ||
            currentStep === `Step4-3`
              ? `current-step4`
              : ``
          }`}
        >
          <em>4</em>
          <ul>
            <li
              className={`${currentStep === `Step4-1` ? `current-step` : ``}`}
            >
              Confirm transaction in your From wallet.
            </li>
            <li
              className={`${currentStep === `Step4-2` ? `current-step` : ``}`}
            >
              Converting token please wait a moment.
            </li>
            <li
              className={`${currentStep === `Step4-3` ? `current-step` : ``}`}
            >
              Confirm transaction in your To wallet.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
